import React from 'react'


function EchecPaiement() {
  return (
    <div>Echec Paiement</div>
  )
}
export default EchecPaiement;